exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icone-audio {\n  cursor: pointer;\n  color: darkslateblue;\n  vertical-align: sub; }\n\n.md-iconHover:hover {\n  color: mediumpurple; }\n\n.pricing-table {\n  box-shadow: 1px 1px 8px -1px rgba(0, 0, 0, 0.18); }\n  .pricing-table .pricing-plan-details .data-details .details-title {\n    display: block; }\n    .pricing-table .pricing-plan-details .data-details .details-title:not(:first-child) {\n      margin-top: 8px; }\n  .pricing-table .pricing-plan-details .data-details.acordo-details {\n    margin-top: 16px; }\n    .pricing-table .pricing-plan-details .data-details.acordo-details .details-title {\n      color: #00b61e; }\n  .pricing-table .pricing-plan-details .data-details.dividas-details .details-title {\n    color: #757575; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/components/contrato/contrato.component.scss
// module id = ../../../../../src/app/components/contrato/contrato.component.scss
// module chunks = main